import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Button, Container, Row, Col } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { isSameDay, toDate, getWeekStart } from '../utils/date';

const DayPicker = ({ currentDate, startDate, onDateSelected }) => {
  const [dateSelected, setDateSelected] = useState(currentDate);

  useEffect(() => {
    setDateSelected(currentDate);
  }, [currentDate]);

  const baseStart = useMemo(() => {
    if (startDate) {
      return toDate(startDate);
    }

    if (currentDate) {
      return getWeekStart(currentDate);
    }

    return getWeekStart(new Date());
  }, [startDate, currentDate]);

  const formatter = useMemo(() => new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
  }), []);

  const days = useMemo(() => {
    return Array.from({ length: 7 }, (_, index) => {
      const dayDate = new Date(baseStart);
      dayDate.setDate(baseStart.getDate() + index);
      return {
        label: dayDate.toLocaleDateString('en-US', { weekday: 'short' }),
        fullDate: dayDate,
        display: formatter.format(dayDate),
      };
    });
  }, [baseStart, formatter]);

  const handleButtonClick = useCallback((date) => {
    setDateSelected(date);
    if (onDateSelected) {
      onDateSelected(date);
    }
  }, [onDateSelected]);

  return (
    <Container className="p-0 w-100">
      <Row className="justify-content-center w-100 m-0">
        {days.map((day, index) => (
          <Col key={index}>
            <Button
              color={isSameDay(dateSelected, day.fullDate) ? 'success' : 'dark'}
              outline={!isSameDay(dateSelected, day.fullDate)}
              onClick={() => handleButtonClick(day.fullDate)}
              block
              className="p-1"
            >
              <div>{day.label}</div>
              <b>{day.display}</b>
            </Button>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DayPicker;
